export default __webpack_public_path__ + "static/winter34-3d72b79244e0ee6287dd864184a20629.webp";